import { Suspense } from 'react'
import VConsole from 'vconsole'

import '@lair-finance/wallet/styles.css'
import '@/shared/lib/sentry'

import Routes from '@/app/routes.tsx'
import { WagmiProvider } from '@/app/providers/wagmi'
import { ReactQueryProvider } from '@/app/providers/react-query'
import { OverlayProvider } from 'overlay-kit'
import { TooltipProvider } from '@/shared/ui/Tooltip'
import { GlobalHooks } from '@/shared/hooks/useGlobalHooks.ts'
import { isDevelopment, isStage } from '@/shared/constants/env.ts'
import { WalletProvider } from '@/domains/wallet/components/WalletProvider.tsx'

if (isDevelopment || isStage) {
  new VConsole()
}

export default function App() {
  return (
    <Suspense>
      <WagmiProvider>
        <ReactQueryProvider>
          <WalletProvider>
            <TooltipProvider delayDuration={120}>
              <OverlayProvider>
                <Routes />
                <GlobalHooks />
              </OverlayProvider>
            </TooltipProvider>
          </WalletProvider>
        </ReactQueryProvider>
      </WagmiProvider>
    </Suspense>
  )
}
